import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"
class Barchart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      series: [
        {
          name: "Lead", 
          data: [12, 24, 42],
         
        },
        {
            name: "Clients", 
            data: [6, 13, 30]
          },
      ],
      options: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#6ce5e8', '#41b8d5'],
       
        grid: {
          borderColor: "#f1f1f1",
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
          ],
        },
      },
    }
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height="350"
          className="apex-charts"
        />
      </React.Fragment>
    )
  }
}

export default Barchart
